import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Layout } from "../../components"

/* Widgets */
import { GameForm, CatalogForm } from "../../widgets/Game"

/* REST API */
import { tables, catalog } from "../../api/Game"

/* Router */
import { Link } from "react-router-dom"

/* Icons */
import { PlusIcon, ArrowIcon, LayersIcon, TypeIcon } from "../../widgets/Game/GameIcons"

/* Translate */
import { t } from "../../translates/translate"


/* THE GROUP EVERY TABLE POINTING AT A GAME OUTSIDE THE CATALOGUE FALLS INTO */
const OTHER = { type: "other", name: "OTHER GAMES", sort: 9999 }


/* Page Games */
class Games extends Component {

    constructor() {
        super()

        this.state = {
            data: [],
            status: "loading",
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load actions — no operator filter anymore, the scope of the token decides which tables come back */
    load = (reload = false) => {

        if (reload) {
            this.setState({ status: "loading" })
        }

        tables({}).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    /* Reload The Catalogue — a new type or a new game must reach the modal right away */
    reloadCatalog = () => {

        /* Fields */
        const { dispatch } = this.props

        catalog().then((response) => {
            if (response && response.status === 200) {
                dispatch({
                    type: "SET_CATALOG",
                    payload: {
                        types: response.data.types || [],
                        games: response.data.games || [],
                        studios: response.data.studios || [],
                        currencies: response.data.currencies || [],
                    },
                })
            }
        }).catch(() => { })
    }


    /* GROUP THE TABLES BY THE TYPE OF THEIR GAME — THE CATALOGUE OF THE DATABASE IS THE ONLY SOURCE */
    grouped = () => {

        /* Fields */
        const { data } = this.state
        const groups = []

        /* Check Data */
        if (!Array.isArray(data)) {
            return groups
        }

        /* Collect */
        for (const table of data) {

            /* The Type Of The Table */
            const type = table.gameType ? table.gameType : OTHER.type
            const name = table.gameTypeName ? table.gameTypeName : OTHER.name
            const sort = table.gameTypeSort !== null && table.gameTypeSort !== undefined ? parseInt(table.gameTypeSort) : OTHER.sort

            /* The Group Of The Type */
            let group = groups.find((item) => item.type === type)

            /* Create The Group */
            if (!group) {
                group = { type, name, sort, tables: [] }
                groups.push(group)
            }

            group.tables.push(table)
        }

        /* Send Result */
        return groups.sort((a, b) => a.sort - b.sort)
    }


    /* Draw A Table Card */
    _table = (table) => (
        <Link to={`/table/${table.game}/${table.uid}`} className={`game ${table.gameType ? table.gameType : "other"} ${table.gameColor ? table.gameColor : "lightblue"}`} key={`${table.id}`}>

            <div className="game-info">

                <div className="game-icon">
                    <TypeIcon type={table.gameType} size={20} />
                </div>

                <div className="game-text">
                    <h2>{table.name}</h2>
                    <span>{table.gameName ? table.gameName : table.game}</span>
                </div>

            </div>

            <div className="game-slug">{table.slug}{table.studio ? ` · ${table.studio}` : ""}</div>

            <div className="game-bottom">

                <div className={`game-available ${parseInt(table.visible) === 1 ? "" : "game-available-offline"}`}>
                    <span className="game-available-dot" />
                    {parseInt(table.visible) === 1 ? t("common.enabled") : t("common.disabled")}
                </div>

                <div className="game-button">
                    {t("common.view")}
                    <ArrowIcon />
                </div>

            </div>

        </Link>
    )


    render = () => {

        /* Fields */
        const { status } = this.state
        const { admin } = this.props

        /* Check Status */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        /* Groups */
        const groups = this.grouped()

        /* Rights — a table, a game and a type are created by a superadmin only */
        const canCreate = admin && admin.access === "superadmin"

        return (
            <div className="page">

                <div className="page-header games--header">

                    <h1>{t("game.title")}</h1>

                    {
                        canCreate ?
                            <div className="games--actions">

                                <div onClick={() => this._catalog.open()} className="button button-ghost games--add">
                                    <LayersIcon size={15} />
                                    <span>{t("game.catalogTitle")}</span>
                                </div>

                                <div onClick={() => this._form.open()} className="button games--add">
                                    <PlusIcon size={15} />
                                    <span>{t("game.add")}</span>
                                </div>

                            </div>
                            : null
                    }

                </div>

                {groups.length === 0 ? <div className="games--empty">{t("game.emptyList")}</div> : null}

                {groups.map((group) =>
                    <div className="games-box" key={group.type}>

                        <div className="games-title">
                            <TypeIcon type={group.type} size={16} />
                            <span>{group.name}</span>
                            <div className="games-count">{group.tables.length}</div>
                        </div>

                        <div className="games">
                            {group.tables.map((table) => this._table(table))}
                        </div>

                    </div>
                )}

                {canCreate ? <GameForm ref={(ref) => this._form = ref} reload={() => this.load(true)} reloadCatalog={() => this.reloadCatalog()} /> : null}

                {canCreate ? <CatalogForm ref={(ref) => this._catalog = ref} reloadCatalog={() => this.reloadCatalog()} /> : null}

            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

export default connect(mapStateToProps)(Games)
